export default {
  resolved: new Map(),
  resolveNSRecords(domain) {
    if (!this.resolved.has(domain)) {
      this.resolved.set(domain, fetch(`https://dns.google/resolve?name=${domain}&type=2`, {
        referrerPolicy: 'no-referrer',
        cache: 'no-cache',
      }).then((response) => {
        return response.json();
      }).then((jsonResponse) => {
        let ns = [];
        if (jsonResponse.Answer) {
          for (const a of jsonResponse.Answer) {
            if (a.type == 2) {
              ns.push(a.data);
            }
          }
        }

        if (ns.length === 0 && jsonResponse.Authority) {
          for (const a of jsonResponse.Authority) {
            if (a.type == 2) {
              ns.push(a.data);
            }
          }
        }

        if (ns.length === 0 && jsonResponse.Authority && jsonResponse.Authority.length > 0) {
          const soa = jsonResponse.Authority.find((a) => a && a.type == 6 && a.name);
          if (soa && soa.name && soa.name !== domain) {
            return this.resolveNSRecords(soa.name);
          }
        }

        return ns;
      }).catch(() => {
        return [];
      }));
    }
    return this.resolved.get(domain);
  },
	resolveNSRecordsByRDAP(domain) {
		return fetch(`https://rdap.org/domain/${domain}`, {
			referrerPolicy: 'no-referrer',
			cache: 'no-cache',
		}).then((response) => {
			return response.json();
		}).then((jsonResponse) => {
			let nameservers = [];
			if (jsonResponse.nameservers) {
				for (let ns of jsonResponse.nameservers) {
					if (ns.endsWith(".")) {
						ns = ns.slice(0, -1);
					}
					nameservers.push(ns.ldhName);
				}
			}
			return nameservers;
		}).catch(() => {
			return [];
		});
	},
  nsStatus(domain, nameservers) {
    return this.resolveNSRecords(domain).then((domainNs) => {
      if (domainNs.length === 0) {
        return "not-found"
      }
      for (let ns of domainNs) {
				if (ns.endsWith(".")) {
					ns = ns.slice(0, -1);
				}
        if (!nameservers.includes(ns)) {
          return "mismatch";
        }
      }
      return "ok";
    });
  },
  aStatus(domain, ip_address) {
    return this.resolveARecord(domain).then((result) => {
      if (result === null) {
        return "not-found"
      }
      if (result != ip_address) {
        return "mismatch";
      }
      return "ok";
    });
  },
  resolveARecord(domain) {
    return fetch(`https://dns.google/resolve?name=${domain}&type=1`, {
      referrerPolicy: 'no-referrer',
      cache: 'no-cache',
    }).then((response) => {
      return response.json();
    }).then((jsonResponse) => {
      if (jsonResponse.Answer) {
        for (const a of jsonResponse.Answer) {
          if (a.type == 1) {
            return a.data;
          }
        }
      }
      return null;
    }).catch(() => {
      return null;
    });
  },
  resolveCNAMERecord(domain) {
    return fetch(`https://dns.google/resolve?name=${domain}&type=5`, {
      referrerPolicy: 'no-referrer',
      cache: 'no-cache',
    }).then((response) => {
      return response.json();
    }).then((jsonResponse) => {
      if (jsonResponse.Answer) {
        for (const a of jsonResponse.Answer) {
          if (a.type == 5) {
            return a.data;
          }
        }
      }
      return null;
    }).catch(() => {
      return null;
    });
  },
  async compareNSRecords(domain, compareWith, eagerDnsVerification) {
    let result = {
      resolving: false,
      matching: false,
    };

		// resolve by google
    await this
      .resolveNSRecords(domain)
      .then((nameservers) => {
        if (nameservers.length === 0) {
          return;
        }
        result.resolving = true;
        for (let ns of nameservers) {
          if (ns.endsWith(".")) {
            ns = ns.slice(0, -1);
          }
          if (!compareWith.includes(ns)) {
            return;
          }
        }
        result.matching = true;
        return;
      });

    if (result.matching) {
      return result;
    }
    if (domain.startsWith('www.')) {
      return this.compareNSRecords(domain.slice(4), compareWith);
    }

		if (eagerDnsVerification) {
			//resolve by rdap for new domains
			await this.resolveNSRecordsByRDAP(domain)
				.then((nameservers) => {
					if (nameservers.length === 0) {
						return;
					}

					result.resolving = true;
					for (let ns of nameservers) {
						if (ns.endsWith(".")) {
							ns = ns.slice(0, -1);
						}
						if (!compareWith.includes(ns)) {
							return;
						}
					}
					result.matching = true;
				})
		}

    return result;
  },
  async cloudflareNSDetected(domain) {
    let detected = await this
      .resolveNSRecords(domain)
      .then((nameservers) => {
        if (nameservers.length === 0) {
          return false;
        }
        for (let ns of nameservers) {
          if (ns.endsWith(".")) {
            ns = ns.slice(0, -1);
          }
          if (!ns.includes('cloudflare')) {
            return false;
          }
        }
        return true;
      });
    if (detected) {
      return detected;
    }
    if (domain.startsWith('www.')) {
      return this.cloudflareNSDetected(domain.slice(4));
    }
    return detected;
  },
  async compareCNAMELikeRecord(domain, validCnameDomains) {
    let result = {
      resolving: false,
      matching: false,
    };
    await this
      .resolveCNAMERecord(domain)
      .then((response) => {
        if (!response) {
          return;
        }
        result.resolving = true;
        if (response.endsWith(".")) {
          response = response.slice(0, -1);
        }
        for (let validDomain of validCnameDomains) {
          if (response.endsWith("." + validDomain)) {
            result.matching = true;
            return;
          }
        }
      });

    if (result.matching) {
      return result;
    }
    if (domain.startsWith('www.')) {
      return this.compareCNAMELikeRecord(domain.slice(4), validCnameDomains);
    }
    return result;
  },
  async compareCNAMERecord(domain, validCnameDomains) {
    let result = {
      resolving: false,
      matching: false,
    };
    await this
      .resolveCNAMERecord(domain)
      .then((response) => {
        if (!response) {
          return;
        }
        result.resolving = true;
        if (response.endsWith(".")) {
          response = response.slice(0, -1);
        }
        for (let validDomain of validCnameDomains) {
          if (response == validDomain) {
            result.matching = true;
            return;
          }
        }
      });

    if (result.matching) {
      return result;
    }
    if (domain.startsWith('www.')) {
      return this.compareCNAMERecord(domain.slice(4), validCnameDomains);
    }
    return result;
  },
  async compareARecord(domain, validIpAddresses) {
    let result = {
      resolving: false,
      matching: false,
    };
    await this
      .resolveARecord(domain)
      .then((response) => {
        if (!response) {
          return;
        }
        result.resolving = true;
        for (let validIp of validIpAddresses) {
          if (response == validIp) {
            result.matching = true;
            return;
          }
        }
      });

    if (result.matching) {
      return result;
    }
    if (domain.startsWith('www.')) {
      return this.compareARecord(domain.slice(4), validIpAddresses);
    }
    return result;
  },
  async verifyDomainResolving(
    domain,
    onboardingSubdomain,
    dnsSettings,
    hasDnsServer,
    ipv4Addresses,
    nameservers,
		hostCNames,
		recordsFromDnsServer,
		eagerDnsVerification = false
  ) {

    if (domain == onboardingSubdomain) {
      // dont verify onboarding subdomains
      return true;
    }

    let verifyMethods = dnsSettings.verification_methods;
    if (!Array.isArray(verifyMethods) || !verifyMethods.length) {
      return true;
    }

    if (verifyMethods.includes("resolve_a_record")) {
			const validIpAddresses = this.getIpv4Addresses(ipv4Addresses)
      let resultA = await this.compareARecord(
        domain,
				validIpAddresses
      );
      if (resultA.matching) {
        return true;
      }
    }
    if (verifyMethods.includes("resolve_ns_records") && hasDnsServer) {
      let resultNS = await this.compareNSRecords(
        domain,
        nameservers,
				eagerDnsVerification
      );
      if (resultNS.matching) {
        return true;
      }
    }
    if (verifyMethods.includes("resolve_cname_record_custom")) {
      let validCnames = dnsSettings.valid_cname_addresses;
      if (Array.isArray(validCnames) && validCnames.length) {
        let resultCNAMECustom = await this.compareCNAMELikeRecord(
          domain,
          validCnames
        );
        if (resultCNAMECustom.matching) {
          return true;
        }
      }
    }
    if (verifyMethods.includes("resolve_cname_record_onboarding")) {
      if (this.onboardingSubdomain) {
        let resultCNAMEOnboarding = await this.compareCNAMERecord(
          domain,
          [onboardingSubdomain]
        );
        if (resultCNAMEOnboarding.matching) {
          return true;
        }
      }
    }
		if (verifyMethods.includes("resolve_records_from_dns_servers")) {
			if (Array.isArray(hostCNames) && hostCNames.length) {
				let resultCNAME = await this.compareCNAMERecord(
					domain,
					hostCNames
				);
				if (!resultCNAME.matching) {
					return false;
				}
			}

			for (const record of recordsFromDnsServer) {
				if (record.type === 'A') {
					let resultA = await this.compareARecord(
						record.name,
						[record.value]
					);
					if (!resultA.matching) {
						return false;
					}
				}

				if (record.type === 'NS') {
					let resultNS = await this.compareNSRecords(
						record.name,
						[record.value],
						eagerDnsVerification
					);
					if (!resultNS.matching) {
						return false;
					}
				}

				if (record.type === 'CNAME') {
					let resultCNAME = await this.compareCNAMERecord(
						record.name,
						[record.value]
					);
					if (!resultCNAME.matching) {
						return false;
					}
				}

				if (record.type === 'TXT') {
					let resultTXT = await this.verifyTXTRecord(
						record.name,
						record.value
					);
					if (!resultTXT) {
						return false;
					}
				}
			}
			return true;
		}
    return false;
  },
	getIpv4Addresses(ipAddresses) {
		const ipv4Addresses = [];
		ipAddresses.forEach((ipAddress) => {
			if (ipAddress.includes("/")) {
				ipv4Addresses.push(...this.generateIPsFromCIDR(ipAddress));
				return
			}
			ipv4Addresses.push(ipAddress);
		})
		return ipv4Addresses;
	},
	generateIPsFromCIDR(cidr) {
		const [baseIP, mask] = cidr.split('/');
		const maskBits = parseInt(mask);

		const baseIPParts = baseIP.split('.').map(part => parseInt(part));
		let baseIPNum = (baseIPParts[0] << 24) |
			(baseIPParts[1] << 16) |
			(baseIPParts[2] << 8) |
			baseIPParts[3];

		const totalIPs = Math.pow(2, 32 - maskBits);

		const networkMask = -1 << (32 - maskBits);
		const firstIPNum = baseIPNum & networkMask;

		const ipList = [];
		for (let i = 0; i < totalIPs; i++) {
			const currentIPNum = firstIPNum + i;
			const ipParts = [
				(currentIPNum >> 24) & 255,
				(currentIPNum >> 16) & 255,
				(currentIPNum >> 8) & 255,
				currentIPNum & 255
			];
			ipList.push(ipParts.join('.'));
		}
		return ipList;
	},
	resolveTXTRecord(domain) {
		return fetch(`https://dns.google/resolve?name=${domain}&type=TXT`, {
			referrerPolicy: 'no-referrer',
			cache: 'no-cache',
		}).then((response) => {
			return response.json();
		}).then((jsonResponse) => {
			if (jsonResponse.Answer) {
				for (const a of jsonResponse.Answer) {
					if (a.type == 16) {
						return a.data;
					}
				}
			}
			return null;
		}).catch(() => {
			return null;
		});
	},
	async compareTXTRecord(name, value) {
		let result = {
			resolving: false,
			matching: false,
		};
		await this
			.resolveTXTRecord(name)
			.then((response) => {
				if (!response) {
					return;
				}
				result.resolving = true;
				if (response == value) {
					result.matching = true;
				}
			});

		if (result.matching) {
			return result;
		}
		return result;
	},
	async verifyTXTRecord(name, value) {
		let result = await this.compareTXTRecord(name, value);
		return result.matching;

	}
}